"use client";

import "@/app/globals.css";
import PageNotFound from "@/components/notFoundComponents/pageNotFound";

export default function NotFound() {
  return (
    <div className="flex flex-col items-center flex-1 overflow-auto w-full">
      <div className="w-full flex flex-col items-center justify-center px-5 my-8 space-y-8 text-center">
        <PageNotFound />
      </div>
    </div>
  );
}
